import React from 'react';
import { Button } from '@economic/taco';
import { t } from '../../../../shared/components/l10n/l10n';
import SignupComputerIllustration from './Signup-computer.png';

interface Props {
    onDone: () => void;
    onCancel: () => void;
}

export default function ConfirmationStart({ onDone, onCancel }: Props) {
    return (
        <>
            <div className="flex flex-col items-center">
                <h1>{t`RACKBEAT_LAGER_ONBOARDING_CONFIRM_HEADER`}</h1>
                <div>
                    <p>
                        <img src={SignupComputerIllustration} className="w-48" />
                    </p>
                </div>
                <div className="mb-4">
                    <div style={{ paddingBottom: '20px' }}>{t`RACKBEAT_LAGER_ONBOARDING_CONFIRM_TEXT1`}</div>
                    <div>{t`RACKBEAT_LAGER_ONBOARDING_CONFIRM_TEXT2`}</div>
                </div>
            </div>
            <div className="text-right space-x-4">
                <Button appearance="default" onClick={() => onCancel()} autoFocus>
                    {t`RACKBEAT_LAGER_ONBOARDING_CONFIRM_CANCEL_BUTTON`}
                </Button>
                <Button appearance="primary" onClick={() => onDone()} autoFocus>
                    {t`RACKBEAT_LAGER_ONBOARDING_CONFIRM_ACCEPT_BUTTON`}
                </Button>
            </div>
        </>
    );
}
